var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTutorialIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 97.88,
    viewBox: "0 0 85 97.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#fff}.cls-2{fill:#041e42}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    transform: "translate(-64 -5256.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M109.5 5269.44a39.433 39.433 0 0 0-12.564 2.053l-1.757-4.792 3.942-1.446a4 4 0 0 0 2.379-5.133l-.345-.939a4 4 0 0 0-5.132-2.378l-5.443 2a2.176 2.176 0 0 0-.56.116 2.12 2.12 0 0 0-.5.274l-6.638 2.435a4 4 0 0 0-2.379 5.132l.345.939a4 4 0 0 0 5.132 2.378l5.138-1.884 1.8 4.9a39.5 39.5 0 1 0 16.587-3.652z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    className: "cls-2",
    transform: "translate(65 5274.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    d: "M104.5 5354.44a40.5 40.5 0 1 1 40.5-40.5 40.546 40.546 0 0 1-40.5 40.5zm0-79a38.5 38.5 0 1 0 38.5 38.5 38.544 38.544 0 0 0-38.5-38.5z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    d: "M117.5 5326.44a1 1 0 0 1-.66-.249l-13.075-11.491a1 1 0 1 1 1.32-1.5l13.075 11.489a1 1 0 0 1-.66 1.751z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    d: "M104.525 5314.98a1 1 0 0 1-1-1l-.025-26.54a1 1 0 0 1 1-1 1 1 0 0 1 1 1l.025 26.54a1 1 0 0 1-1 1z",
    className: "cls-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    fill: "#041e42",
    fillRule: "evenodd",
    d: "M96.5 5265.122l-.345-.939a4 4 0 0 0-5.133-2.378l-5.442 2a2.176 2.176 0 0 0-.56.116 2.12 2.12 0 0 0-.5.274l-5.375 1.971a4 4 0 0 0-2.379 5.133l.344.939a4 4 0 0 0 5.133 2.378l3.876-1.421 3.7 10.1a2.164 2.164 0 0 0 4.064-1.491l-3.7-10.094 3.942-1.446a4 4 0 0 0 2.375-5.142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    d: "M91.848 5285.706a3.17 3.17 0 0 1-2.969-2.076l-3.358-9.156-2.936 1.077a5.005 5.005 0 0 1-6.416-2.973l-.345-.939a5 5 0 0 1 2.974-6.415l5.258-1.929a2.871 2.871 0 0 1 1.3-.475l5.325-1.954a5.008 5.008 0 0 1 6.416 2.973l.345.94a5.006 5.006 0 0 1-2.974 6.415l-3 1.1 3.357 9.156a3.167 3.167 0 0 1-2.971 4.255zm-5.138-13.8l4.046 11.033a1.164 1.164 0 0 0 2.186-.8l-4.042-11.033 4.88-1.79a3 3 0 0 0 1.785-3.85l-.344-.938a3.007 3.007 0 0 0-3.851-1.784l-5.7 2.053a1.228 1.228 0 0 0-.3.059 1.136 1.136 0 0 0-.264.148l-.237.126-5.376 1.972a3 3 0 0 0-1.784 3.849l.345.939a3 3 0 0 0 3.849 1.783z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 34,
    cy: 34,
    r: 34,
    className: "cls-2",
    transform: "translate(70.5 5279.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    d: "M104.5 5348.94a35 35 0 1 1 35-35 35.04 35.04 0 0 1-35 35zm0-68a33 33 0 1 0 33 33 33.038 33.038 0 0 0-33-33z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    className: "cls-3",
    transform: "translate(99 5308.44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    fill: "#00aed6",
    d: "M14.193 34.696L0 0",
    transform: "translate(93.468 5286.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    d: "M107.661 5322.416a1 1 0 0 1-.926-.623L92.543 5287.1a1 1 0 1 1 1.852-.757l14.192 34.7a1 1 0 0 1-.926 1.379z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    d: "M121.531 5308.968l-2.928 4.21a3.665 3.665 0 0 1 2.657 3.521 3.765 3.765 0 0 1-3.906 3.681 4.6 4.6 0 0 1-4-1.9l1.888-1.473a2.5 2.5 0 0 0 2.113 1.121 1.453 1.453 0 1 0 0-2.9H114.6v-.017l2.9-4.081h-3.649v-2.193h7.682z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    d: "M122.584 5316.635v-4.21a3.909 3.909 0 0 1 7.812 0v4.21a3.909 3.909 0 0 1-7.812 0zm5.475 0v-4.21a1.58 1.58 0 0 0-3.154 0v4.21a1.58 1.58 0 0 0 3.154 0z",
    className: "cls-3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon3);
export default __webpack_public_path__ + "static/media/tutorial-icon-3.4b3fa7047ddf9760883731ae39ea02d4.svg";
export { ForwardRef as ReactComponent };